"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const context_1 = require("@apollo/client/link/context");
const SwitchBranchCookieHelper_1 = require("@aurora/shared-utils/helpers/developer/SwitchBranchCookieHelper");
const constants_1 = require("@aurora/shared-types/developer/constants");
const log_1 = require("@aurora/shared-utils/log");
const log = (0, log_1.getLog)(module);
/**
 * Link that adds branch header to all request made.
 */
function getBranchHeaderLink() {
    return (0, context_1.setContext)((_, { headers }) => __awaiter(this, void 0, void 0, function* () {
        const branchName = (0, SwitchBranchCookieHelper_1.getBranchNameFromCookie)(headers === null || headers === void 0 ? void 0 : headers.cookie);
        if (!(0, SwitchBranchCookieHelper_1.isMainBranch)(branchName)) {
            log.debug('Using branch: %s', branchName);
            return {
                headers: Object.assign(Object.assign({}, headers), { [constants_1.BRANCH_NAME_KEY]: branchName })
            };
        }
        return {
            headers
        };
    }));
}
exports.default = getBranchHeaderLink;
//# sourceMappingURL=branchHeaderLink.js.map